import { basicAuthOptions, bearerAuthOptions } from "./util";
import { apiUrl } from "../config";
import axios from "axios";

export function getCertificates(language) {
	const options = { ...bearerAuthOptions };
	if (language) {
		options.headers = { ...options.headers, "Accept-Language": language };
	}
	return axios.get(`${apiUrl}/certificates`, options).then(r => r.data);
}

export function getCertificate(classID, language) {
	const options = { ...bearerAuthOptions };
	if (language) {
		options.headers = { ...options.headers, "Accept-Language": language };
	}
	return axios.get(`${apiUrl}/certificate/${classID}`, options).then(r => r.data);
}

export function getCertificateById(certificateID, language) {
	const options = { ...basicAuthOptions };
	if (language) {
		options.headers = { ...options.headers, "Accept-Language": language };
	}
	return axios.post(`${apiUrl}/certificate`, { certificateID }, options).then(r => r.data);
}



// WEBPACK FOOTER //
// ./src/api/certificate.js